import React, { Ref } from "react";
import { NavLink } from "react-router-dom";
import DatepickerLayout from "../../layouts/datepicker-layout/DatepickerLayout";
import MyPerformanceState, { MyPerformanceProps } from "./MyPerformance.models";
import './MyPerformance.scss';
import { PeriodDateJson } from "../../../models/dtos/chart/PeriodDateJson";
import StudentDailyReports from "../../../services/work-report/StudentDailyReports";
import { PeriodDate, PeriodDateTypeString } from "../../../models/interfaces/chart/PeriodDate";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import MyPerformanceImage from '../../../assest/images/card-image/ItemAvatar.png';

export default class MyPerformance extends React.PureComponent<MyPerformanceProps, MyPerformanceState> {

    studentDailyReports: StudentDailyReports;
    constructor(props: any) {
        super(props);
        this.studentDailyReports = new StudentDailyReports();
        this.state = { hasData: false, periodTitle: PeriodDate.CurrentMonth, totalTest: 0, totalTime: { hour: 0, minute: 0 }, worksReport: [], isActiveDatePicker: false };
    }

    selectPeridDate = (periodDate: PeriodDateJson) => {
        let self = this;

        self.studentDailyReports.getReportByRange({
            fromDate: periodDate.persianCreationFrom,
            toDate: periodDate.persianCreationTo
        }).then(function (response) {

            if (response.length > 0) {
                let worksReport = response;

                let totalStudyTime = 0;
                let totalTest = 0;
                worksReport.map(report => {

                    totalStudyTime += (report.studyTime.hour * 60) + report.studyTime.minute;
                    totalTest += report.testPassedCount;
                });
                let hour = Math.floor(totalStudyTime / 60);
                let minute = totalStudyTime - (hour * 60);
                let totalTimeHour = hour >= 0 ? hour : 0;
                let totalTimeMinute = minute >= 0 ? minute : 0;

                self.setState({ hasData: true, worksReport: response, totalTime: { hour: totalTimeHour, minute: totalTimeMinute }, totalTest: totalTest, periodTitle: periodDate.periodDate });
            }

            else
                self.setState({ hasData: false });
        });


    }

    onHandleDatePicker = (value: boolean) => {
        this.setState({ isActiveDatePicker: value });
    }

    render(): React.ReactNode {
        let { hasData, periodTitle, totalTest, totalTime, worksReport } = this.state;

        let content;

        let topStudentBanner = <>
            <NavLink to={"/TopStudents"}>
                <div className="top-student-banner mt-3">
                    <label>برترین های برنده ساز</label>
                </div>
            </NavLink>
        </>;

        if (hasData) {
            content = (<>
                <div className="my-performance-area">
                    {topStudentBanner}
                    <div className="Found-data">
                        <div className="tk-header">
                            <label>عملکرد من در {PeriodDateTypeString(periodTitle)}</label>
                        </div>
                        <div className="col-12 notspace">
                            <div className="row">
                                <div className="col-6">
                                    <div className="tk-card total">
                                        <label>ساعت کل مطالعه</label>
                                        <label style={{ direction: "ltr" }}> {totalTime.hour}  : {totalTime.minute}  </label>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="tk-card total">
                                        <label>تعداد کل تست </label>
                                        <label>{totalTest}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-list" style={this.state.isActiveDatePicker ? { height: "18vh", overflowX: "hidden" } : { height: "42vh", overflowX: "hidden", paddingBottom: " 74px" }}>
                            {worksReport.map((workReport, key) => {
                                return <div key={key} className="tk-card">
                                    <div className="col-12 notspace tk-aling-right tk-direction-right">
                                        <div className="tk-inline">
                                            <div className="col-1 notspace" style={{ maxWidth: "56px" }}>
                                                <img src={MyPerformanceImage} alt="my performance icon" />
                                            </div>
                                            <div className="col-7 col-md-8 coustom-width">
                                                <div className="corseDetail">
                                                    <div className="Couse-title">
                                                        <label>{workReport.courseTitle}</label>
                                                    </div>
                                                    <div className="Couse-subtitle">
                                                        <label>میزان مطالعه {workReport.studyTime.hour}:{workReport.studyTime.minute}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-3 number-test " style={{ direction: "ltr" }}>
                                                <div style={{ height: "15px" }}>
                                                    <label>تعداد تست</label>
                                                </div>
                                                <div className="exam">
                                                    <label>{workReport.testPassedCount}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>

            </>);
        }
        else {
            content = (<>
                {topStudentBanner}
                <NotFoundDataInDate />
            </>);
        }
        return (<>
            <DatepickerLayout isActiveDatePicker={this.state.isActiveDatePicker} onHandleActiveDatePicker={this.onHandleDatePicker} showFooter={true} afterInit={periodTitle} afterSelect={this.selectPeridDate} children={content} headerAction={true} title="عملکرد من" />
        </>);
    }
}